<template>
  <div>
    <div class="btn-wrap">
      <div class="btn"
      v-for="(item,index) in btnGroup"
      :key="index"
      @click="btnClick('item'+index, index)"
      :class="btnActive === index ? 'btnActive': ''"
      >
        <div class="num">{{item.num}}</div>
        <div class="status">
          <span class="tip" v-if="item.status !== '所有状态'" :style="{background:(item.colorful)}"></span>
          <span class="infos">
            {{item.status}}
          </span>
        </div>
      </div>
    </div>
    <el-input
    placeholder="请输入DeviceName"
    v-model="input"
    @focus="inputFocus"
    @blur="inputBlur"
    :class="active ? 'active' : '' "
    @keyup.13.native="deviceHandlerKeyUp"
    >
      <el-button slot="append" icon="el-icon-search" @click="clickHandler" ></el-button>
    </el-input>
    <!-- table表格 -->
    <el-table
      :header-cell-style="{background:'#eef1f6',color:'#606266'}"
      :data="deviceList"
      class="table"
      ref="multipleTable"
      style="margin-bottom:20px"
      @selection-change="handleSelectionChange"
      >
      <!-- <el-table-column
        v-if="btnActive !== 0"
        type="selection"
        width="55">
      </el-table-column>  先不做全选-->
      <el-table-column
        prop="deviceName"
        label="DeviceName"
        width="180">
      </el-table-column>
      <el-table-column
        prop="productKey"
        label="产品">
      </el-table-column>
      <el-table-column
        prop="deviceVersion"
        label="升级前版本号">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="状态更新时间">
      </el-table-column>
      <el-table-column
        prop="upgradeStatus"
        label="状态">
          <template slot-scope="scope">
          <span class="tip" :style="{background:(scope.row.upgradeStatus === 0 ? '#888888': scope.row.upgradeStatus === 1 ? '#0070cc': scope.row.upgradeStatus === 2 ? 'yellow': scope.row.upgradeStatus === 3 ? 'green' : scope.row.upgradeStatus === 4 ? 'red': scope.row.upgradeStatus === 5 ? '#ff8a00' : '')}"></span>

          <span style="margin-right: left">{{ scope.row.upgradeStatus === 0 ? '待推送': scope.row.upgradeStatus === 1 ? '已推送': scope.row.upgradeStatus === 2 ? '升级中': scope.row.upgradeStatus === 3 ? '升级成功' : scope.row.upgradeStatus === 4 ? '升级失败': scope.row.upgradeStatus === 5 ? '已取消' : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="upgradeStep"
        label="升级进度">
      </el-table-column>
      <!-- <el-table-column
        prop="statusMsg"
        label="状态详情">
      </el-table-column> -->
      <el-table-column
        v-if="!(btnActive === 3 || btnActive === 4)"
        label="操作">
        <template slot-scope="scope">
          <el-popconfirm
            :title="scope.row.upgradeStatus === 0 || scope.row.upgradeStatus === 1 ? '是否取消升级' : scope.row.upgradeStatus === 5 || scope.row.upgradeStatus === 4 ? '是否重定向' : ''"
            placement="top-start"
            v-if="btnActive === 0"
            @onConfirm="tableClick('all',scope.row)"
          >
            <el-button
              type="text"
              size="small"
              v-if="btnActive === 0"
              :disabled="row.batchStatus===4"
              slot="reference"
              >
              {{ scope.row.upgradeStatus === 0 || scope.row.upgradeStatus === 1 ? '取消升级' : scope.row.upgradeStatus === 5 || scope.row.upgradeStatus === 4 ? '重升级' : '' }}
            </el-button>
          </el-popconfirm>
          <!--                    选择待推送跟已推送                            -->
          <el-popconfirm
            title="是否取消升级"
            placement="top-start"
            v-if="btnActive === 1 || btnActive === 2"
            @onConfirm="tableClick('cancle', scope.row)"
          >
            <el-button
              type="text"
              size="small"
              slot="reference"
              :disabled="row.batchStatus===4"
              v-if="btnActive === 1 || btnActive === 2"
              >
              取消升级
            </el-button>
          </el-popconfirm>
          <!--                    选择升级失败和已取消                            -->
          <el-popconfirm
            title="是否重升级"
            placement="top-start"
            v-if="btnActive === 5 || btnActive === 6"
            @onConfirm="tableClick('again', scope.row)"
          >
            <el-button
              type="text"
              size="small"
              slot="reference"
              :disabled="row.batchStatus===4"
              v-if="btnActive === 5 || btnActive === 6"
              >
              重升级
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div class="batch-operation" v-if="deviceList.length !== 0 && btnActive !== 0 && btnActive !== 3 && btnActive !== 4">
      <el-checkbox v-model="checked" class="check" @change="toggleSelect(deviceList)"></el-checkbox>
      <el-button class="btn">批量取消</el-button>
    </div>     TODO: 先不做-->
    <!-- 分页管理 -->
    <Paging :total="total" @changePage="changePage"/>
  </div>
</template>
<script>
import Paging from '@/components/paging'
import { getDeviceByStrategyId, cancelUp, reUpgrade, statisticsDevice } from '@/api/productControl' // cancelUp
export default {
  components: {
    Paging
  },
  data () {
    return {
      row: null,
      active: false,
      input: '',
      btnActive: 0,
      btnGroup: [
        {
          num: 0,
          status: '所有状态'
        },
        {
          num: 0,
          status: '待推送',
          colorful: '#888888'
        },
        {
          num: 0,
          status: '已推送',
          colorful: '#0070cc'
        },
        {
          num: 0,
          status: '升级中',
          colorful: 'yellow'
        },
        {
          num: 0,
          status: '升级成功',
          colorful: 'green'
        },
        {
          num: 0,
          status: '升级失败',
          colorful: 'red'
        },
        {
          num: 0,
          status: '已取消',
          colorful: '#ff8a00'
        }
      ],
      deviceList: [],
      multipleSelection: [],
      params: {},
      // checked: false // 全选/全不选  批量操作功能，先不做
      // 分页功能
      total: 0, // 到时候从后台获取
      // listLoading: false, // 根据loading来进行显示/隐藏
      listQuery: {
        page: 1,
        limit: 10
      }
    }
  },
  created () {
    this.row = JSON.parse(this.$route.query.row)
    this.params.firmwareId = this.row.firmwareId
    this.params.strategyId = this.row.strategyId
  },
  mounted () {
    this.getDeviceList()
    this.getTotal()
  },
  methods: {
    getDeviceList () {
      if (this.params.deviceName === '') delete this.params.deviceName
      this.params.pageNum = this.listQuery.page
      this.params.pageSize = this.listQuery.limit
      const params = {
        params: this.params
      }
      getDeviceByStrategyId(params) // TODO: 添加固件id
        .then((e) => {
          this.deviceList = e.data.data.list
          this.total = e.data.data.total
          this.deviceList.forEach((ele) => {
            if (ele.upgradeStatus === 3) {
              ele.upgradeStep = '100%'
            } else if (ele.upgradeStatus === 2) {
              ele.upgradeStep = ele.upgradeStep + '%'
            } else {
              ele.upgradeStep = '-'
            }
          })
          // if (e.data.data.total < 15) this.listLoading = true
        })
    },
    getTotal () {
      const params = { // TODO: 固件ID
        params: this.params
      }
      statisticsDevice(params)
        .then(res => {
          const num = res.data.data
          this.btnGroup.forEach((item) => {
            switch (item.status) {
              case '所有状态':
                item.num = num.alreadyPushNum + num.cancelNum + num.upgradeFailNum + num.upgradeSuccessNum + num.upgradingNum + num.waitingPushNum
                break
              case '待推送':
                item.num = num.waitingPushNum
                break
              case '已推送':
                item.num = num.alreadyPushNum
                break
              case '升级中':
                item.num = num.upgradingNum
                break
              case '升级成功':
                item.num = num.upgradeSuccessNum
                break
              case '升级失败':
                item.num = num.upgradeFailNum
                break
              case '已取消':
                item.num = num.cancelNum
                break
            }
          })
        })
    },
    // 分页管理
    changePage (val) {
      this.listQuery = val
      this.getDeviceList()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      /* if (this.multipleSelection.length === this.deviceList.length) {
        this.checked = true
      } else {
        this.checked = false
      } */
      console.log(this.multipleSelection)
    },
    /* toggleSelect (rows) {
      console.log(rows)
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    }, */
    btnClick (val, index) {
      this.listQuery.page = 1
      delete this.params.upgradeStatus
      switch (val) {
        case 'item0':
          this.btnActive = 0
          break
        case 'item1':
          this.btnActive = 1
          this.params.upgradeStatus = 0
          break
        case 'item2':
          this.btnActive = 2
          this.params.upgradeStatus = 1
          break
        case 'item3':
          this.btnActive = 3
          this.params.upgradeStatus = 2
          break
        case 'item4':
          this.btnActive = 4
          this.params.upgradeStatus = 3
          break
        case 'item5':
          this.btnActive = 5
          this.params.upgradeStatus = 4
          break
        case 'item6':
          this.btnActive = 6
          this.params.upgradeStatus = 5
          break
      }
      console.log(this.btnActive)
      this.getDeviceList()
    },
    // 取消升级接口
    toCancelUp (params) {
      cancelUp(params).then(res => {
        if (res.data.code === 200) {
          this.$message({
            type: 'success',
            message: '取消升级操作成功'
          })
          setTimeout(() => {
            this.listQuery.page = 1
            this.getDeviceList()
            this.getTotal()
          }, 0)
        }
      })
    },
    // 重升级
    toReUpgrade (params) {
      reUpgrade(params).then(res => {
        if (res.data.code === 200) {
          this.$message({
            type: 'success',
            message: '重升级操作成功'
          })
          setTimeout(() => {
            this.listQuery.page = 1
            this.getDeviceList()
            this.getTotal()
          }, 0)
        }
      })
    },
    tableClick (val, row) {
      const params = {
        params: {
          strategyId: row.strategyId,
          productKey: row.productKey,
          deviceName: row.deviceName,
          firmwareId: this.row.firmwareId
        }
      }
      switch (val) {
        case 'all':
          console.log(row)
          if (row.upgradeStatus === 4 || row.upgradeStatus === 5) {
            this.toReUpgrade(params)
          } else {
            this.toCancelUp(params)
          }
          break
        case 'cancle':
          this.toCancelUp(params)
          break
        case 'again':
          this.toReUpgrade(params)
          break
      }
    },
    // 输入框聚焦
    inputFocus () {
      this.active = true
    },
    // 输入框失焦
    inputBlur () {
      this.active = false
    },
    // 13键
    deviceHandlerKeyUp (e) {
      if (e.keyCode === 13) {
        this.listQuery.page = 1
        this.clickHandler()
      }
    },
    // 搜索功能
    clickHandler () {
      this.listQuery.page = 1
      this.params.deviceName = this.input
      this.getDeviceList()
    }
  }
}
</script>
<style lang='less' scoped>
  .btn-wrap{
    display: flex;
    margin-bottom: 8px;
    cursor: pointer;
    .btn{
      width: 120px;
      height: 64px;
      padding: 6px 0 0 12px;
      border: 1px solid #c6cbd1;
      border-radius: 3px;
      margin-right: 9px;
    }
    .status{
      .tip{
        height: 8px;
        width: 8px;
        border-radius: 50%;
        background: #888;
        display: inline-block;
        margin-right: 8px;
      }
    }
    .btnActive{
      border: 1px solid springgreen;
    }
  }
  .batch-operation{
    /deep/ .el-checkbox__input{
      margin-left: 10px;
      margin-right: 10px;
    }
    /deep/ .el-button{
      padding: 8px;
    }
  }
  .el-button{
      border-radius: 0;
    }
  .el-input{
    box-sizing: border-box !important;
    margin-bottom: 8px;
    width: 20%;
    border: 1px solid #dedede;
    transition: all .3s ease-out;
    -webkit-transition: all .3s ease-out;
    /deep/ .el-input__inner{
      border: none !important;
      height: 38px;
      line-height: 38px;
    }
    /deep/ .el-input-group__append{
      background-color: white !important;
      color: #555 !important;
      border: none !important;
    }
    /deep/ .el-icon-search{
      color: orange;
      font-size: 20px;
      font-weight: bold;
    }
  }
  .tip{
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background: #888;
    display: inline-block;
    margin-right: 8px;
  }
  .active{
    border-color: #737373;
    transition: all .3s ease-out;
    -webkit-transition: all .3s ease-out;
  }
  /deep/  .el-table-column--selection{
    .cell{
      padding-left: 10px;
    }
  }
</style>
